//#region imports
import { Component, OnInit, AfterViewChecked } from '@angular/core';
import { GuaranteeService } from 'src/app/services/guarantee.service';
import { NotificationService } from 'src/app/services/notification.service';
import { TranslateService } from '@ngx-translate/core';
import { Globals } from 'src/app/services/globals';
import { Pricing } from '../../model/guarantee.model';
import { SectionService } from 'src/app/services/section.service';
import {PixelService} from 'ngx-pixel';
//#endregion

@Component({
  selector: 'app-guarantee-question1',
  templateUrl: './guarantee-question1.component.html',
  styleUrls: ['./guarantee-question1.component.css']
})
export class GuaranteeQuestion1Component implements OnInit, AfterViewChecked {
  //#region variables
  premiumVATFireBuildingStr: string;
  pricingData: Pricing;
  //#endregion

  //#region methods
  constructor(
    private notification: NotificationService, private globals: Globals, private sectionService: SectionService,
    private translate: TranslateService, private guaranteeService: GuaranteeService, private pixel:PixelService) {
    this.guaranteeService.setshowNormalTitle(true);
  }

  ngOnInit() {
    this.sectionService.setCurrentPage('P3-1');
    this.globals.trackPageActivity += ';' + 'P3-1';
    this.pixel.track('InitiateCheckout');
    this.pricingData = this.guaranteeService.getInitialPricingData();
    this.premiumVATFireBuildingStr = this.pricingData.Tarification.Premium_VAT_Fire_Building;
  }

  ngAfterViewChecked() {
    this.globals.guaranteeHeader1 = true;
  }
  ngAfterContentInit()
  {
    const propertyDestinationRenting = this.guaranteeService.getPropertyDestinationRenting();
    if(this.globals.isContentFirsttime === false && propertyDestinationRenting === false)
    {
      this.globals.isContentFirsttime = true;
      this.guaranteeService.oncheckedChangeContent(false);      
    }
  }

  helpDialog(value: string) {
    value = this.translate.instant(value);
    this.notification.openDialog(value);
  }
  //#endregion
}
